import { normalizeSet } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var setClipboard = normalizeSet(function (args) {
  var _ref = args || {},
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text,
      _ref$success = _ref.success,
      success = _ref$success === void 0 ? function () {} : _ref$success,
      _ref$fail = _ref.fail,
      fail = _ref$fail === void 0 ? function () {} : _ref$fail,
      _ref$complete = _ref.complete,
      complete = _ref$complete === void 0 ? function () {} : _ref$complete;

  var textArea;

  var createTextArea = function createTextArea() {
    textArea = document.createElement('textArea');
    textArea.style.position = 'absolute';
    textArea.style.top = 0;
    textArea.style.opacity = 0;
    textArea.style.zIndex = -1;
    textArea.value = text;
    document.body.appendChild(textArea);
  };

  var selectText = function selectText() {
    textArea.setAttribute('readonly', '');
    textArea.select();
    textArea.setSelectionRange(0, textArea.value.length);
  };

  var copyToClipboard = function copyToClipboard() {
    document.execCommand('copy');
    textArea.remove();
  };

  try {
    createTextArea();
    selectText();
    copyToClipboard();
    success(text);
    complete(text);
    return text;
  } catch (error) {
    fail(error);
    complete(text);
  }
}, CONTAINER_NAME.WEB);
export default setClipboard;